module.exports = __webpack_public_path__ + "static/Inter-SemiBold-8bcb84d706f7e89845fc65a7e5ca4832.woff2";